import React from 'react';
import Image from 'react-bootstrap/Image';
import styles from './styles/styles.module.scss';

class ProfileIcon extends React.Component {
  render() {
    return (
      <span>
        <Image className={styles.profile} roundedCircle src={this.props.imagePath} />
      </span>
    );
  }
}

export default ProfileIcon;
